/* ♥ buttons on product cards + product page → wishlist (dw-wishlist.js). */
(() => {
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.8-4.7-9.4-9.4C1.4 7.6 3.7 4.3 7.1 4.3c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.4 0 5.7 3.3 4.5 6.8-1.6 4.7-9.4 9.4-9.4 9.4z"/></svg>';
  const cache = {};
  const handleOf = (href) => {
    const m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };
  const wl = () => window.DawbuWishlist;

  async function product(handle) {
    if (!cache[handle]) cache[handle] = fetch(`/products/${encodeURIComponent(handle)}.js`).then((r) => r.json());
    return cache[handle];
  }

  function paint(btn) {
    const on = !!(wl() && btn.dataset.variant && wl().has(btn.dataset.variant));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
  }

  async function toggle(btn) {
    if (!wl()) return;
    const p = await product(btn.dataset.handle);
    const v = p.variants.find((x) => x.available) || p.variants[0];
    btn.dataset.variant = v.id;
    if (wl().has(v.id)) wl().remove(v.id);
    else
      wl().add({
        id: v.id,
        handle: p.handle,
        title: p.title,
        price: v.price,
        image: (p.featured_image || '').replace(/^\/\//, 'https://') + ((p.featured_image || '').includes('?') ? '&' : '?') + 'width=160',
        url: '/products/' + p.handle,
      });
    btn.classList.add('is-pop');
    setTimeout(() => btn.classList.remove('is-pop'), 400);
    paint(btn);
  }

  function makeBtn(handle) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'hw-heart';
    b.dataset.handle = handle;
    b.setAttribute('aria-label', 'Save to wishlist');
    b.innerHTML = HEART;
    return b;
  }

  function decorate() {
    document.querySelectorAll('.ccg-media, .card-wrapper .card__inner').forEach((media) => {
      if (media.querySelector('.hw-heart')) return;
      const a = media.matches('a[href*="/products/"]') ? media : media.querySelector('a[href*="/products/"]') || media.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
      const h = a && handleOf(a.getAttribute('href'));
      if (h) media.appendChild(makeBtn(h));
    });
    // Product page: beside the add-to-cart button
    if (window.ShopifyAnalytics && location.pathname.includes('/products/')) {
      const h = handleOf(location.pathname);
      const spot = document.querySelector('[data-hwp-form], .product-form__buttons, product-form, .product-form');
      if (h && spot && !document.querySelector('.hw-heart--pdp')) {
        const b = makeBtn(h);
        b.classList.add('hw-heart--pdp');
        b.insertAdjacentHTML('beforeend', '<span>Add to wishlist</span>');
        spot.parentNode.insertBefore(b, spot.nextSibling);
      }
    }
    document.querySelectorAll('.hw-heart').forEach(async (b) => {
      if (b.dataset.variant || !wl()) return;
      const items = wl().items();
      const hit = items.find((i) => i.handle === b.dataset.handle);
      if (hit) b.dataset.variant = hit.id;
      paint(b);
    });
  }

  document.addEventListener(
    'click',
    (e) => {
      const b = e.target.closest('.hw-heart');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(b);
    },
    true
  );
  document.addEventListener('dw:wishlist-change', () =>
    document.querySelectorAll('.hw-heart').forEach((b) => {
      const hit = wl().items().find((i) => i.handle === b.dataset.handle);
      if (hit) b.dataset.variant = hit.id;
      paint(b);
    })
  );

  const start = () => {
    decorate();
    new MutationObserver(() => {
      clearTimeout(start.t);
      start.t = setTimeout(decorate, 200);
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
